import { gql } from 'urql';

const DELETE_ACTION_FILE = gql`
  mutation DeleteActionFile($fileId: Int!, $id: Int!, $activity: String, $timestamp: bigint, $userId: Int) {
    delete_action_files_by_pk(id: $fileId) {
      id
    }
    insert_actions_activity_one(
      object: { activity: $activity, entity_id: $id, timestamp: $timestamp, user_id: $userId }
    ) {
      id
    }
  }
`;

export default DELETE_ACTION_FILE;
